import axiosInstance from '../axiosInterceptor/axiosInstance'

const deleteSeason = async (orgId, seasonId) => {
  const url = `v1/orgs/${orgId}/seasons/${seasonId}`
  const response = await axiosInstance.delete(url)
  return response?.data
}

export default deleteSeason
